import { Box, Card, useTabContext, getPanelId, getTabId } from 'bonfire-kindling';

const SavedSearchSettingsCreateTabPanel = ({ children, sx, value, ...props }) => {
  // Avoid using `TabPanel` since it conditionally mounts children based on the active
  // tab. See PV-1522 for more info.
  const context = useTabContext();
  const id = getPanelId(context, value);
  const tabId = getTabId(context, value);

  return (
    <Box
      id={id}
      role="tabpanel"
      aria-labelledby={tabId}
      hidden={value !== context.value}
      sx={{
        mt: 5,
        ml: { xs: 4, lg: 8 },
        flex: '1 1 0%',
        py: 0,
        px: 1,
        ...sx,
      }}
      {...props}
    >
      <Card sx={{ width: '100%', p: 4 }}>{children}</Card>
    </Box>
  );
};

export default SavedSearchSettingsCreateTabPanel;
